export default __webpack_public_path__ + "static/media/N_Navio.a49897ba.mp3";